import { useMediaQuery } from '@direct-frontend/stdlib';
import { type ThemeColor } from '../themekit';
import { DARK_COLOR_SCHEME_QUERY } from './constants';
import { resolveThemeColor } from './getTheme';
import { useThemeMode } from './useThemeMode';

export const useThemeColor = (): ThemeColor => {
    const { mode } = useThemeMode();
    // На SSR для system считаем light (matchMedia недоступен)
    const isSystemDark = useMediaQuery(DARK_COLOR_SCHEME_QUERY);

    return resolveThemeColor({ isSystemDark, mode });
};
